'use client';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { faro } from '@grafana/faro-react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { getEnv } from '@/lib/env';

const FARO_URLS = {
    sbox: 'https://faro-collector-prod-gb-south-1.grafana.net/collect/07728637292fe96fdfb5e088642c01c1',
    prod: 'https://faro-collector-prod-gb-south-1.grafana.net/collect/d58c913d3c5f9dff7bd95b68f1988fc9',
}

export function FaroInitializer() {
    const pathname = usePathname();
    useEffect(() => {
        if (typeof window !== 'undefined' &&
            !window.location.hostname.includes('localhost') &&
            !window.location.hostname.includes('127.0.0.1')) {

            const env = getEnv();

            initializeFaro({
                url: process.env.NEXT_PUBLIC_GRAFANA_FARO_URL || FARO_URLS[env as keyof typeof FARO_URLS],
                app: {
                    name: `ceylon-bike-rent-${env}`,
                    version: process.env.NEXT_PUBLIC_GRAFANA_FARO_APP_VERSION || process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
                    environment: env,
                },
                sessionTracking: {
                    samplingRate: 1,
                    persistent: true,
                },
                instrumentations: [
                    // Mandatory, automatically captures errors, logs, and performance metrics
                    ...getWebInstrumentations({
                        captureConsole: true,
                    }),
                    // Optional, captures detailed tracing for performance analysis
                    new TracingInstrumentation(),
                ],
            });
        }
    }, []);

    useEffect(() => {
        if (faro.api) {
            faro.api.setView({ name: pathname });
        }
    }, [pathname]);

    return null;
}
